export function filesize(size) {
  const i = Math.floor(Math.log(size) / Math.log(1024))
  return (
    (size / Math.pow(1024, i)).toFixed(2) * 1 +
    ' ' +
    ['B', 'kB', 'MB', 'GB', 'TB'][i]
  )
}

export function getItemStatus(itemPercentage) {
  return itemPercentage < 5 ? 'red' : itemPercentage < 20 ? 'amber' : 'green'
}

export function getSerNo(links, index) {
    const activePage = links.find((link) => link.active);

    const currentPage = activePage.label - 1;

    return currentPage * 10 + (index + 1);
}

export function getLabel(item) {
    if (item === 'brooms') {
        return 'Brooms (1.5 Kg)'
    }

    if (item === 'wiper') {
        return 'Wiper (Articles)'
    }

    if (item === 'normal_waste_21_bag') {
        return 'Normal Waste Bags 21x28 (1 Kg ~ 30 bags)'
    }

    if (item === 'normal_waste_30_bag') {
        return 'Normal Waste Bags 30x30 (1 Kg ~ 16 bags)'
    }

    if (item === 'normal_waste_39_bag') {
        return 'Normal Waste Bags 39x45 (1 Kg ~ 8 bags)';
    }

    if (item === 'furniture_dusters') {
        return 'Furniture Dusters (Articles)'
    }

    if (item === 'disinfectant') {
        return 'Disinfectant (2.75 Lit Bottle)'
    }

    if (item === 'hand_wash_liquid') {
        return 'Hand Wash Liquid (Liters)'
    }

    if (item === 'air_freshener') {
        return 'Air Freshener (Bottles)'
    }

    if (item === 'mop_pads') {
        return 'Mop Pads (Articles)'
    }

    if (item === 'liquid_toilet_cleaner') {
        return 'Liquid Toilet Cleaner (900 ml Bottle)'
    }

    if (item === 'floor_mops_standard') {
        return 'Floor Mops Standard (Articles)'
    }

    if (item === 'hand_wash_dispenser') {
        return 'Hand Wash Dispenser (Articles)';
    }

    if (item === 'floor_cleaning_towels') {
        return 'Floor cleaning towels (Articles)'
    }

    if (item === 'disposable_bed_sheets') {
        return 'Disposable Bed Sheets';
    }

    if (item === 'air_freshener_2') {
        return 'Air Freshener Dispenser (Machines) (New)';
    }

    if (item === 'air_freshener_3') {
        return 'Air Freshener Dispenser Refills (New)';
    }

    return '';
}
